//@flow

import type {Action} from '../actions/actions';
import * as actions from '../actions/actions';
import type {Show} from '../store';

const defaultShow: Show = Object.assign({}, {
  id: '',
  title: '',
  slug: '',
  airings: [],
  episodeAirings: [],
  description: '',
  mezzanine: '',
  website_url: '',
  site_button_text: '',
  resourceLinks: {
    DVD: [],
    externalSite: [],
  },
  sponsors: [],
  related_shows: [
    {
      related_show_title: '',
      related_show_poster: '',
      related_show_link: '',
    }
  ],
  seasons: [],
  livestream: {
    isLive: false,
    service: null
  },
  storyboard: null,
  blocks: [],
  promos: [],
  fetchingShow: false,
  fetchedShow: false,
  error: null,
}, window.initialShow || {});

let initialShow = defaultShow;

/**
 * These actions handle fetching show data.
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default function show(state: Show = initialShow, action: Action): Show {

  switch (action.type) {

    case actions.FETCHING_SHOW_DATA:
      return Object.assign(
        {},
        state, {fetchingShow: true, fetchedShow: false, error: null}
      );

    case actions.FETCHING_SHOW_DATA_ERROR:
      return Object.assign(
        {},
        state, {fetchingShow: false, fetchedShow: false, error: action.payload}
      );

    case actions.RECEIVED_SHOW_DATA:
      return Object.assign(
        {},
        action.payload,
        {
          fetchedShow: true,
          fetchingShow: false
        }
      );

    case actions.RECEIVED_SCHEDULED_EPISODES:
      return Object.assign(
        {},
        state,
        {episodeAirings: action.payload}
      );

    default:
      return state;
  }

};
